import { Component, OnInit } from '@angular/core';
import { StorageService } from '../Services/storage.service';
import { HttpQueriesService } from '../Services/http-queries.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-congres-virtuel-login-backdoor',
  templateUrl: './congres-virtuel-login-backdoor.component.html',
  styleUrls: ['./congres-virtuel-login-backdoor.component.scss']
})
export class CongresVirtuelLoginBackdoorComponent implements OnInit {

  auth = {email:null, pass:null};

  logging = false;

  constructor(private router:Router, private storageservice:StorageService, private httpservice:HttpQueriesService) { }

  ngOnInit() {
  }

  connect(){
    this.logging = true;
    this.httpservice.congresLogin(this.auth).subscribe(val=>{
      this.logging = false;
      console.log(val)
      this.storageservice.setCongresConUser(val);
      this.router.navigateByUrl('/congres-virtuel');
      this.auth = {email:null, pass:null};

    }, error=>{
      this.logging = false;
        
      if(error.error == 'cred'){
        alert("Votre identifiant / Mot de passe incorrect.");

      }else{
        alert("erreur d'authentification.");

      }

    });

  }

}
